import { Warning } from "@/assets/icons/ds";

/** Id of a field's error message, for the field's aria-describedby. */
export const getErrorMessageId = (name: string) => `${name}-error`;

export const ErrorMessage = ({
  name,
  message,
}: {
  name: string;
  message?: string;
}) => {
  return message ? (
    <p
      id={getErrorMessageId(name)}
      data-testid={`${name}-alert`}
      className="mt-2 flex items-center gap-2 text-body-xs text-foreground-error"
      role="alert"
    >
      <Warning className="h-4 w-4 shrink-0" aria-hidden />
      {message}
    </p>
  ) : null;
};
